(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('@material/tab-indicator'), require('rxjs/operators'), require('@angular/common/http'), require('@angular/platform-browser'), require('rxjs'), require('@material/ripple'), require('@material/tab'), require('@material/tab-scroller'), require('@material/tab-bar')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/tab-bar', ['exports', '@angular/core', '@angular/common', '@angular/cdk/coercion', '@angular/cdk/platform', '@material/tab-indicator', 'rxjs/operators', '@angular/common/http', '@angular/platform-browser', 'rxjs', '@material/ripple', '@material/tab', '@material/tab-scroller', '@material/tab-bar'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.tabBar = {}), global.ng.core, global.ng.common, global.ng.cdk.coercion, global.ng.cdk.platform, global.mdc.tabIndicator, global.rxjs.operators, global.ng.common.http, global.ng.platformBrowser, global.rxjs, global.mdc.ripple, global.mdc.tab, global.mdc.tabScroller, global.mdc.tabBar));
}(this, (function (exports, i0, i3, coercion, platform, tabIndicator, operators, i1, i2, rxjs, ripple, tab, tabScroller, tabBar) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcTabIndicator = /** @class */ (function (_super) {
        __extends(MdcTabIndicator, _super);
        function MdcTabIndicator(_platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._isFoundationInit = false;
            _this._active = false;
            _this._fade = false;
            _this._icon = null;
            return _this;
        }
        Object.defineProperty(MdcTabIndicator.prototype, "active", {
            get: function () { return this._active; },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (this._active !== newValue) {
                    this._active = coercion.coerceBooleanProperty(newValue);
                    this._active ? this.activate(this.computeContentClientRect()) : this.deactivate();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabIndicator.prototype, "fade", {
            get: function () { return this._fade; },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._fade) {
                    this._fade = newValue;
                    this._initFoundation();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabIndicator.prototype, "icon", {
            get: function () { return this._icon; },
            set: function (value) {
                this._icon = value;
                this._updateContentClasses();
            },
            enumerable: true,
            configurable: true
        });
        MdcTabIndicator.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                computeContentClientRect: function () {
                    if (!_this._platform.isBrowser) {
                        return { height: 0, width: 0, bottom: 0, top: 0, left: 0, right: 0 };
                    }
                    return _this.content.nativeElement.getBoundingClientRect();
                },
                setContentStyleProperty: function (propName, value) {
                    return _this.content.nativeElement.style.setProperty(propName, value);
                }
            };
            return this._fade ? new tabIndicator.MDCFadingTabIndicatorFoundation(adapter) : new tabIndicator.MDCSlidingTabIndicatorFoundation(adapter);
        };
        MdcTabIndicator.prototype.ngAfterViewInit = function () {
            if (!this._isFoundationInit) {
                this._initFoundation();
                this._updateContentClasses();
            }
        };
        MdcTabIndicator.prototype.activate = function (previousIndicatorClientRect) {
            if (this._foundation) {
                this._foundation.activate(previousIndicatorClientRect);
            }
        };
        MdcTabIndicator.prototype.deactivate = function () {
            if (this._foundation) {
                this._foundation.deactivate();
            }
        };
        MdcTabIndicator.prototype.computeContentClientRect = function () {
            return this._foundation.computeContentClientRect();
        };
        MdcTabIndicator.prototype._initFoundation = function () {
            this._foundation.init();
            this._isFoundationInit = true;
            this._changeDetectorRef.markForCheck();
        };
        MdcTabIndicator.prototype._updateContentClasses = function () {
            this.content.nativeElement.classList.remove('mdc-tab-indicator__content--underline');
            this.content.nativeElement.classList.remove('mdc-tab-indicator__content--icon');
            if (this.icon) {
                this.content.nativeElement.classList.add('mdc-tab-indicator__content--icon');
                this.content.nativeElement.classList.add('material-icons');
            }
            else {
                this.content.nativeElement.classList.add('mdc-tab-indicator__content--underline');
            }
            this._changeDetectorRef.markForCheck();
        };
        /** Retrieves the DOM element of the component host. */
        MdcTabIndicator.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTabIndicator.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcTabIndicator], mdc-tab-indicator',
                        exportAs: 'mdcTabIndicator',
                        host: {
                            'class': 'mdc-tab-indicator',
                            '[class.mdc-tab-indicator--active]': 'active',
                            '[class.mdc-tab-indicator--fade]': 'fade'
                        },
                        template: "<span #content class=\"mdc-tab-indicator__content\">\r\n  <ng-container *ngIf=\"icon\">{{icon}}</ng-container>\r\n</span>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcTabIndicator.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef }
        ]; };
        MdcTabIndicator.propDecorators = {
            active: [{ type: i0.Input }],
            fade: [{ type: i0.Input }],
            icon: [{ type: i0.Input }],
            content: [{ type: i0.ViewChild, args: ['content', { static: true },] }]
        };
        return MdcTabIndicator;
    }(MDCComponent));

    var MdcTabIndicatorModule = /** @class */ (function () {
        function MdcTabIndicatorModule() {
        }
        MdcTabIndicatorModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [i3.CommonModule],
                        exports: [MdcTabIndicator],
                        declarations: [MdcTabIndicator]
                    },] }
        ];
        return MdcTabIndicatorModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcMaterialIcons = /** @class */ (function () {
        function MdcMaterialIcons() {
        }
        MdcMaterialIcons.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[materialIcons]',
                        host: {
                            'class': 'material-icons'
                        }
                    },] }
        ];
        return MdcMaterialIcons;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Returns an exception to be thrown in the case when attempting to
     * load an icon with a name that cannot be found.
     */
    function getMdcIconNameNotFoundError(iconName) {
        return Error("Unable to find icon with the name \"" + iconName + "\"");
    }
    /**
     * Returns an exception to be thrown when the consumer attempts to use
     * `<mdc-icon>` without including @angular/common/http.
     * @docs-private
     */
    function getMdcIconNoHttpProviderError() {
        return Error('Could not find HttpClient provider for use with Angular Material icons. ' +
            'Please include the HttpClientModule from @angular/common/http in your ' +
            'app imports.');
    }
    /**
     * Returns an exception to be thrown when a URL couldn't be sanitized.
     * @param url URL that was attempted to be sanitized.
     * @docs-private
     */
    function getMdcIconFailedToSanitizeUrlError(url) {
        return Error("The URL provided to MatIconRegistry was not trusted as a resource URL " +
            ("via Angular's DomSanitizer. Attempted URL was \"" + url + "\"."));
    }
    /**
     * Returns an exception to be thrown when a HTML string couldn't be sanitized.
     * @param literal HTML that was attempted to be sanitized.
     * @docs-private
     */
    function getMdcIconFailedToSanitizeLiteralError(literal) {
        return Error("The literal provided to MatIconRegistry was not trusted as safe HTML by " +
            ("Angular's DomSanitizer. Attempted literal was \"" + literal + "\"."));
    }
    /**
     * Configuration for an icon, including the URL and possibly the cached SVG element.
     * @docs-private
     */
    var SvgIconConfig = /** @class */ (function () {
        function SvgIconConfig(data, options) {
            this.options = options;
            this.url = null;
            this.svgElement = null;
            // Note that we can't use `instanceof SVGElement` here,
            // because it'll break during server-side rendering.
            if (!!data.nodeName) {
                this.svgElement = data;
            }
            else {
                this.url = data;
            }
        }
        return SvgIconConfig;
    }());
    /**
     * Service to register and display icons used by the `<mdc-icon>` component.
     * - Registers icon URLs by namespace and name.
     * - Registers icon set URLs by namespace.
     * - Registers aliases for CSS classes, for use with icon fonts.
     * - Loads icons from URLs and extracts individual icons from icon sets.
     */
    var MdcIconRegistry = /** @class */ (function () {
        function MdcIconRegistry(_httpClient, _sanitizer, document) {
            this._httpClient = _httpClient;
            this._sanitizer = _sanitizer;
            /**
             * URLs and cached SVG elements for individual icons. Keys are of the format "[namespace]:[icon]".
             */
            this._svgIconConfigs = new Map();
            /**
             * SvgIconConfig objects and cached SVG elements for icon sets, keyed by namespace.
             * Multiple icon sets can be registered under the same namespace.
             */
            this._iconSetConfigs = new Map();
            /** Cache for icons loaded by direct URLs. */
            this._cachedIconsByUrl = new Map();
            /** In-progress icon fetches. Used to coalesce multiple requests to the same URL. */
            this._inProgressUrlFetches = new Map();
            /** Map from font identifiers to their CSS class names. Used for icon fonts. */
            this._fontCssClassesByAlias = new Map();
            /**
             * The CSS classes to apply when an `<mdc-icon>` component has no icon name, url, or font specified.
             * The default 'material-icons' value assumes that the material icon font has been loaded as
             * described at http://google.github.io/material-design-icons/#icon-font-for-the-web
             */
            this._defaultFontSetClass = ['material-icons'];
            this._document = document;
        }
        /**
         * Registers an icon by URL in the default namespace.
         * @param iconName Name under which the icon should be registered.
         * @param url
         */
        MdcIconRegistry.prototype.addSvgIcon = function (iconName, url, options) {
            return this.addSvgIconInNamespace('', iconName, url, options);
        };
        /**
         * Registers an icon using an HTML string in the default namespace.
         * @param iconName Name under which the icon should be registered.
         * @param literal SVG source of the icon.
         */
        MdcIconRegistry.prototype.addSvgIconLiteral = function (iconName, literal, options) {
            return this.addSvgIconLiteralInNamespace('', iconName, literal, options);
        };
        /**
         * Registers an icon by URL in the specified namespace.
         * @param namespace Namespace in which the icon should be registered.
         * @param iconName Name under which the icon should be registered.
         * @param url
         */
        MdcIconRegistry.prototype.addSvgIconInNamespace = function (namespace, iconName, url, options) {
            return this._addSvgIconConfig(namespace, iconName, new SvgIconConfig(url, options));
        };
        /**
         * Registers an icon using an HTML string in the specified namespace.
         * @param namespace Namespace in which the icon should be registered.
         * @param iconName Name under which the icon should be registered.
         * @param literal SVG source of the icon.
         */
        MdcIconRegistry.prototype.addSvgIconLiteralInNamespace = function (namespace, iconName, literal, options) {
            var sanitizedLiteral = this._sanitizer.sanitize(i0.SecurityContext.HTML, literal);
            if (!sanitizedLiteral) {
                throw getMdcIconFailedToSanitizeLiteralError(literal);
            }
            var svgElement = this._createSvgElementForSingleIcon(sanitizedLiteral, options);
            return this._addSvgIconConfig(namespace, iconName, new SvgIconConfig(svgElement, options));
        };
        /**
         * Registers an icon set by URL in the default namespace.
         * @param url
         */
        MdcIconRegistry.prototype.addSvgIconSet = function (url, options) {
            return this.addSvgIconSetInNamespace('', url, options);
        };
        /**
         * Registers an icon set using an HTML string in the default namespace.
         * @param literal SVG source of the icon set.
         */
        MdcIconRegistry.prototype.addSvgIconSetLiteral = function (literal, options) {
            return this.addSvgIconSetLiteralInNamespace('', literal, options);
        };
        /**
         * Registers an icon set by URL in the specified namespace.
         * @param namespace Namespace in which to register the icon set.
         * @param url
         */
        MdcIconRegistry.prototype.addSvgIconSetInNamespace = function (namespace, url, options) {
            return this._addSvgIconSetConfig(namespace, new SvgIconConfig(url, options));
        };
        /**
         * Registers an icon set using an HTML string in the specified namespace.
         * @param namespace Namespace in which to register the icon set.
         * @param literal SVG source of the icon set.
         */
        MdcIconRegistry.prototype.addSvgIconSetLiteralInNamespace = function (namespace, literal, options) {
            var sanitizedLiteral = this._sanitizer.sanitize(i0.SecurityContext.HTML, literal);
            if (!sanitizedLiteral) {
                throw getMdcIconFailedToSanitizeLiteralError(literal);
            }
            var svgElement = this._svgElementFromString(sanitizedLiteral);
            return this._addSvgIconSetConfig(namespace, new SvgIconConfig(svgElement, options));
        };
        /**
         * Defines an alias for a CSS class name to be used for icon fonts. Creating an mdcIcon
         * component with the alias as the fontSet input will cause the class name to be applied
         * to the `<mdc-icon>` element.
         *
         * @param alias Alias for the font.
         * @param className Class name override to be used instead of the alias.
         */
        MdcIconRegistry.prototype.registerFontClassAlias = function (alias, className) {
            if (className === void 0) { className = alias; }
            this._fontCssClassesByAlias.set(alias, className);
            return this;
        };
        /**
         * Returns the CSS class name associated with the alias by a previous call to
         * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
         */
        MdcIconRegistry.prototype.classNameForFontAlias = function (alias) {
            return this._fontCssClassesByAlias.get(alias) || alias;
        };
        /**
         * Sets the CSS class name to be used for icon fonts when an `<mdc-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         *
         * @param className
         */
        MdcIconRegistry.prototype.setDefaultFontSetClass = function () {
            var classNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                classNames[_i] = arguments[_i];
            }
            this._defaultFontSetClass = classNames;
            return this;
        };
        /**
         * Returns the CSS class name to be used for icon fonts when an `<mdc-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         */
        MdcIconRegistry.prototype.getDefaultFontSetClass = function () {
            return this._defaultFontSetClass;
        };
        /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
         * The response from the URL may be cached so this will not always cause an HTTP request, but
         * the produced element will always be a new copy of the originally fetched icon. (That is,
         * it will not contain any modifications made to elements previously returned).
         *
         * @param safeUrl URL from which to fetch the SVG icon.
         */
        MdcIconRegistry.prototype.getSvgIconFromUrl = function (safeUrl) {
            var _this = this;
            var url = this._sanitizer.sanitize(i0.SecurityContext.RESOURCE_URL, safeUrl);
            if (!url) {
                throw getMdcIconFailedToSanitizeUrlError(safeUrl);
            }
            var cachedIcon = this._cachedIconsByUrl.get(url);
            if (cachedIcon) {
                return rxjs.of(cloneSvg(cachedIcon));
            }
            return this._loadSvgIconFromConfig(new SvgIconConfig(safeUrl)).pipe(operators.tap(function (svg) { return _this._cachedIconsByUrl.set(url, svg); }), operators.map(function (svg) { return cloneSvg(svg); }));
        };
        /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
         * and namespace. The icon must have been previously registered with addIcon or addIconSet;
         * if not, the Observable will throw an error.
         *
         * @param name Name of the icon to be retrieved.
         * @param namespace Namespace in which to look for the icon.
         */
        MdcIconRegistry.prototype.getNamedSvgIcon = function (name, namespace) {
            if (namespace === void 0) { namespace = ''; }
            // Return (copy of) cached icon if possible.
            var key = iconKey(namespace, name);
            var config = this._svgIconConfigs.get(key);
            if (config) {
                return this._getSvgFromConfig(config);
            }
            // See if we have any icon sets registered for the namespace.
            var iconSetConfigs = this._iconSetConfigs.get(namespace);
            if (iconSetConfigs) {
                return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
            }
            return rxjs.throwError(getMdcIconNameNotFoundError(key));
        };
        MdcIconRegistry.prototype.ngOnDestroy = function () {
            this._svgIconConfigs.clear();
            this._iconSetConfigs.clear();
            this._cachedIconsByUrl.clear();
        };
        /**
         * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
         */
        MdcIconRegistry.prototype._getSvgFromConfig = function (config) {
            if (config.svgElement) {
                // We already have the SVG element for this icon, return a copy.
                return rxjs.of(cloneSvg(config.svgElement));
            }
            else {
                // Fetch the icon from the config's URL, cache it, and return a copy.
                return this._loadSvgIconFromConfig(config).pipe(operators.tap(function (svg) { return config.svgElement = svg; }), operators.map(function (svg) { return cloneSvg(svg); }));
            }
        };
        /**
         * Attempts to find an icon with the specified name in any of the SVG icon sets.
         * First searches the available cached icons for a nested element with a matching name, and
         * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
         * that have not been cached, and searches again after all fetches are completed.
         * The returned Observable produces the SVG element if possible, and throws
         * an error if no icon with the specified name can be found.
         */
        MdcIconRegistry.prototype._getSvgFromIconSetConfigs = function (name, iconSetConfigs) {
            var _this = this;
            // For all the icon set SVG elements we've fetched, see if any contain an icon with the
            // requested name.
            var namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
            if (namedIcon) {
                // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
                // time anyway, there's probably not much advantage compared to just always extracting
                // it from the icon set.
                return rxjs.of(namedIcon);
            }
            // Not found in any cached icon sets. If there are icon sets with URLs that we haven't
            // fetched, fetch them now and look for iconName in the results.
            var iconSetFetchRequests = iconSetConfigs
                .filter(function (iconSetConfig) { return !iconSetConfig.svgElement; })
                .map(function (iconSetConfig) {
                return _this._loadSvgIconSetFromConfig(iconSetConfig).pipe(operators.catchError(function (err) {
                    var url = _this._sanitizer.sanitize(i0.SecurityContext.RESOURCE_URL, iconSetConfig.url);
                    // Swallow errors fetching individual URLs so the
                    // combined Observable won't necessarily fail.
                    console.error("Loading icon set URL: " + url + " failed: " + err.message);
                    return rxjs.of(null);
                }));
            });
            // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
            // cached SVG element (unless the request failed), and we can check again for the icon.
            return rxjs.forkJoin(iconSetFetchRequests).pipe(operators.map(function () {
                var foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
                if (!foundIcon) {
                    throw getMdcIconNameNotFoundError(name);
                }
                return foundIcon;
            }));
        };
        /**
         * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
         * tag matches the specified name. If found, copies the nested element to a new SVG element and
         * returns it. Returns null if no matching element is found.
         */
        MdcIconRegistry.prototype._extractIconWithNameFromAnySet = function (iconName, iconSetConfigs) {
            // Iterate backwards, so icon sets added later have precedence.
            for (var i = iconSetConfigs.length - 1; i >= 0; i--) {
                var config = iconSetConfigs[i];
                if (config.svgElement) {
                    var foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName, config.options);
                    if (foundIcon) {
                        return foundIcon;
                    }
                }
            }
            return null;
        };
        /**
         * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
         * from it.
         */
        MdcIconRegistry.prototype._loadSvgIconFromConfig = function (config) {
            var _this = this;
            return this._fetchUrl(config.url)
                .pipe(operators.map(function (svgText) { return _this._createSvgElementForSingleIcon(svgText, config.options); }));
        };
        /**
         * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
         * from it.
         */
        MdcIconRegistry.prototype._loadSvgIconSetFromConfig = function (config) {
            var _this = this;
            // If the SVG for this icon set has already been parsed, do nothing.
            if (config.svgElement) {
                return rxjs.of(config.svgElement);
            }
            return this._fetchUrl(config.url).pipe(operators.map(function (svgText) {
                // It is possible that the icon set was parsed and cached by an earlier request, so parsing
                // only needs to occur if the cache is yet unset.
                if (!config.svgElement) {
                    config.svgElement = _this._svgElementFromString(svgText);
                }
                return config.svgElement;
            }));
        };
        /**
         * Creates a DOM element from the given SVG string, and adds default attributes.
         */
        MdcIconRegistry.prototype._createSvgElementForSingleIcon = function (responseText, options) {
            var svg = this._svgElementFromString(responseText);
            this._setSvgAttributes(svg, options);
            return svg;
        };
        /**
         * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
         * tag matches the specified name. If found, copies the nested element to a new SVG element and
         * returns it. Returns null if no matching element is found.
         */
        MdcIconRegistry.prototype._extractSvgIconFromSet = function (iconSet, iconName, options) {
            // Use the `id="iconName"` syntax in order to escape special
            // characters in the ID (versus using the #iconName syntax).
            var iconSource = iconSet.querySelector("[id=\"" + iconName + "\"]");
            if (!iconSource) {
                return null;
            }
            // Clone the element and remove the ID to prevent multiple elements from being added
            // to the page with the same ID.
            var iconElement = iconSource.cloneNode(true);
            iconElement.removeAttribute('id');
            // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
            // the content of a new <svg> node.
            if (iconElement.nodeName.toLowerCase() === 'svg') {
                return this._setSvgAttributes(iconElement, options);
            }
            // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
            // that the same could be achieved by referring to it via <use href="#id">, however the <use>
            // tag is problematic on Firefox, because it needs to include the current page path.
            if (iconElement.nodeName.toLowerCase() === 'symbol') {
                return this._setSvgAttributes(this._toSvgElement(iconElement), options);
            }
            // createElement('SVG') doesn't work as expected; the DOM ends up with
            // the correct nodes, but the SVG content doesn't render. Instead we
            // have to create an empty SVG node using innerHTML and append its content.
            // Elements created using DOMParser.parseFromString have the same problem.
            // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
            var svg = this._svgElementFromString('<svg></svg>');
            // Clone the node so we don't remove it from the parent icon set element.
            svg.appendChild(iconElement);
            return this._setSvgAttributes(svg, options);
        };
        /**
         * Creates a DOM element from the given SVG string.
         */
        MdcIconRegistry.prototype._svgElementFromString = function (str) {
            var div = this._document.createElement('DIV');
            div.innerHTML = str;
            var svg = div.querySelector('svg');
            if (!svg) {
                throw Error('<svg> tag not found');
            }
            return svg;
        };
        /**
         * Converts an element into an SVG node by cloning all of its children.
         */
        MdcIconRegistry.prototype._toSvgElement = function (element) {
            var svg = this._svgElementFromString('<svg></svg>');
            var attributes = element.attributes;
            // Copy over all the attributes from the `symbol` to the new SVG, except the id.
            for (var i = 0; i < attributes.length; i++) {
                var _a = attributes[i], name_1 = _a.name, value = _a.value;
                if (name_1 !== 'id') {
                    svg.setAttribute(name_1, value);
                }
            }
            for (var i = 0; i < element.childNodes.length; i++) {
                if (element.childNodes[i].nodeType === this._document.ELEMENT_NODE) {
                    svg.appendChild(element.childNodes[i].cloneNode(true));
                }
            }
            return svg;
        };
        /**
         * Sets the default attributes for an SVG element to be used as an icon.
         */
        MdcIconRegistry.prototype._setSvgAttributes = function (svg, options) {
            svg.setAttribute('fit', '');
            svg.setAttribute('height', '100%');
            svg.setAttribute('width', '100%');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
            if (options && options.viewBox) {
                svg.setAttribute('viewBox', options.viewBox);
            }
            return svg;
        };
        /**
         * Returns an Observable which produces the string contents of the given URL. Results may be
         * cached, so future calls with the same URL may not cause another HTTP request.
         */
        MdcIconRegistry.prototype._fetchUrl = function (safeUrl) {
            var _this = this;
            if (!this._httpClient) {
                throw getMdcIconNoHttpProviderError();
            }
            if (safeUrl == null) {
                throw Error("Cannot fetch icon from URL \"" + safeUrl + "\".");
            }
            var url = this._sanitizer.sanitize(i0.SecurityContext.RESOURCE_URL, safeUrl);
            if (!url) {
                throw getMdcIconFailedToSanitizeUrlError(safeUrl);
            }
            // Store in-progress fetches to avoid sending a duplicate request for a URL when there is
            // already a request in progress for that URL. It's necessary to call share() on the
            // Observable returned by http.get() so that multiple subscribers don't cause multiple XHRs.
            var inProgressFetch = this._inProgressUrlFetches.get(url);
            if (inProgressFetch) {
                return inProgressFetch;
            }
            // TODO(jelbourn): for some reason, the `finalize` operator "loses" the generic type on the
            // Observable. Figure out why and fix it.
            var req = this._httpClient.get(url, { responseType: 'text' }).pipe(operators.finalize(function () { return _this._inProgressUrlFetches.delete(url); }), operators.share());
            this._inProgressUrlFetches.set(url, req);
            return req;
        };
        /**
         * Registers an icon config by name in the specified namespace.
         * @param namespace Namespace in which to register the icon config.
         * @param iconName Name under which to register the config.
         * @param config Config to be registered.
         */
        MdcIconRegistry.prototype._addSvgIconConfig = function (namespace, iconName, config) {
            this._svgIconConfigs.set(iconKey(namespace, iconName), config);
            return this;
        };
        /**
         * Registers an icon set config in the specified namespace.
         * @param namespace Namespace in which to register the icon config.
         * @param config Config to be registered.
         */
        MdcIconRegistry.prototype._addSvgIconSetConfig = function (namespace, config) {
            var configNamespace = this._iconSetConfigs.get(namespace);
            if (configNamespace) {
                configNamespace.push(config);
            }
            else {
                this._iconSetConfigs.set(namespace, [config]);
            }
            return this;
        };
        MdcIconRegistry.decorators = [
            { type: i0.Injectable, args: [{ providedIn: 'root' },] }
        ];
        /** @nocollapse */
        MdcIconRegistry.ctorParameters = function () { return [
            { type: i1.HttpClient, decorators: [{ type: i0.Optional }] },
            { type: i2.DomSanitizer },
            { type: undefined, decorators: [{ type: i0.Optional }, { type: i0.Inject, args: [i3.DOCUMENT,] }] }
        ]; };
        MdcIconRegistry.ɵprov = i0.ɵɵdefineInjectable({ factory: function MdcIconRegistry_Factory() { return new MdcIconRegistry(i0.ɵɵinject(i1.HttpClient, 8), i0.ɵɵinject(i2.DomSanitizer), i0.ɵɵinject(i3.DOCUMENT, 8)); }, token: MdcIconRegistry, providedIn: "root" });
        return MdcIconRegistry;
    }());
    /** @docs-private */
    function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, sanitizer, document) {
        return parentRegistry || new MdcIconRegistry(httpClient, sanitizer, document);
    }
    /** @docs-private */
    var ICON_REGISTRY_PROVIDER = {
        // If there is already an MdcIconRegistry available, use that. Otherwise, provide a new one.
        provide: MdcIconRegistry,
        deps: [
            [new i0.Optional(), new i0.SkipSelf(), MdcIconRegistry],
            [new i0.Optional(), i1.HttpClient],
            i2.DomSanitizer,
            [new i0.Optional(), i3.DOCUMENT],
        ],
        useFactory: ICON_REGISTRY_PROVIDER_FACTORY,
    };
    /** Clones an SVGElement while preserving type information. */
    function cloneSvg(svg) {
        return svg.cloneNode(true);
    }
    /** Returns the cache key to use for an icon namespace and name. */
    function iconKey(namespace, name) {
        return namespace + ':' + name;
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function MDC_ICON_LOCATION_FACTORY() {
        var _document = i0.inject(i3.DOCUMENT);
        var _location = _document ? _document.location : null;
        return {
            // Note that this needs to be a function, rather than a property, because Angular
            // will only resolve it once, but we want the current path on each call.
            getPathname: function () { return _location ? (_location.pathname + _location.search) : ''; }
        };
    }
    /**
     * Injection token used to provide the current location to `MdcIcon`.
     * Used to handle server-side rendering and to stub out during unit tests.
     */
    var MDC_ICON_LOCATION = new i0.InjectionToken('mdc-icon-location', {
        providedIn: 'root',
        factory: MDC_ICON_LOCATION_FACTORY
    });
    /** SVG attributes that accept a FuncIRI (e.g. `url(<something>)`). */
    var funcIriAttributes = [
        'clip-path',
        'color-profile',
        'src',
        'cursor',
        'fill',
        'filter',
        'marker',
        'marker-start',
        'marker-mid',
        'marker-end',
        'mask',
        'stroke'
    ];
    var ɵ0 = function (attr) { return "[" + attr + "]"; };
    /** Selector that can be used to find all elements that are using a `FuncIRI`. */
    var funcIriAttributeSelector = funcIriAttributes.map(ɵ0).join(', ');
    /** Regex that can be used to extract the id out of a FuncIRI. */
    var funcIriPattern = /^url\(['"]?#(.*?)['"]?\)$/;
    var MdcIcon = /** @class */ (function () {
        function MdcIcon(elementRef, _iconRegistry, ariaHidden, _location) {
            this.elementRef = elementRef;
            this._iconRegistry = _iconRegistry;
            this._location = _location;
            this._previousFontSetClass = [];
            this._inline = false;
            this.role = 'img';
            this._fontSet = '';
            this._fontIcon = '';
            if (!ariaHidden) {
                this._getHostElement().setAttribute('aria-hidden', 'true');
            }
        }
        Object.defineProperty(MdcIcon.prototype, "inline", {
            /**
             * Whether the icon should be inlined, automatically sizing the icon to match the font size of
             * the element the icon is contained in.
             */
            get: function () {
                return this._inline;
            },
            set: function (inline) {
                this._inline = coercion.coerceBooleanProperty(inline);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcIcon.prototype, "fontSet", {
            /** Font set that the icon is a part of. */
            get: function () {
                return this._fontSet;
            },
            set: function (value) {
                this._fontSet = this._cleanupFontValue(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcIcon.prototype, "fontIcon", {
            /** Name of an icon within a font set. */
            get: function () {
                return this._fontIcon;
            },
            set: function (value) {
                this._fontIcon = this._cleanupFontValue(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcIcon.prototype.ngAfterViewChecked = function () {
            var cachedElements = this._elementsWithExternalReferences;
            if (cachedElements && this._location && cachedElements.size) {
                var newPath = this._location.getPathname();
                // We need to check whether the URL has changed on each change detection since
                // the browser doesn't have an API that will let us react on link clicks and
                // we can't depend on the Angular router. The references need to be updated,
                // because while most browsers don't care whether the URL is correct after
                // the first render, Safari will break if the user navigates to a different
                // page and the SVG isn't re-rendered.
                if (newPath !== this._previousPath) {
                    this._previousPath = newPath;
                    this._prependPathToReferences(newPath);
                }
            }
        };
        MdcIcon.prototype.ngOnDestroy = function () {
            var _a;
            (_a = this._elementsWithExternalReferences) === null || _a === void 0 ? void 0 : _a.clear();
        };
        /**
         * Splits an svgIcon binding value into its icon set and icon name components.
         * Returns a 2-element array of [(icon set), (icon name)].
         * The separator for the two fields is ':'. If there is no separator, an empty
         * string is returned for the icon set and the entire value is returned for
         * the icon name. If the argument is falsy, returns an array of two empty strings.
         * Throws an error if the name contains two or more ':' separators.
         * Examples:
         *   `'social:cake' -> ['social', 'cake']
         *   'penguin' -> ['', 'penguin']
         *   null -> ['', '']
         *   'a:b:c' -> (throws Error)`
         */
        MdcIcon.prototype._splitIconName = function (iconName) {
            if (!iconName) {
                return ['', ''];
            }
            var parts = iconName.split(':');
            switch (parts.length) {
                case 1: return ['', parts[0]]; // Use default namespace.
                case 2: return parts;
                default: throw Error("Invalid icon name: \"" + iconName + "\"");
            }
        };
        MdcIcon.prototype.ngOnChanges = function (changes) {
            var _this = this;
            // Only update the inline SVG icon if the inputs changed, to avoid unnecessary DOM operations.
            var svgIconChanges = changes['svgIcon'];
            if (svgIconChanges) {
                if (this.svgIcon) {
                    var _a = __read(this._splitIconName(this.svgIcon), 2), namespace = _a[0], iconName = _a[1];
                    this._iconRegistry.getNamedSvgIcon(iconName, namespace).pipe(operators.take(1)).subscribe(function (svg) { return _this._setSvgElement(svg); }, function (err) { return console.log("Error retrieving icon: " + err.message); });
                }
                else if (svgIconChanges.previousValue) {
                    this._clearSvgElement();
                }
            }
            if (this._usingFontIcon()) {
                this._updateFontIconClasses();
            }
        };
        MdcIcon.prototype.ngOnInit = function () {
            // Update font classes because ngOnChanges won't be called if none of the inputs are present,
            // e.g. <mdc-icon>arrow</mdc-icon> In this case we need to add a CSS class for the default font.
            if (this._usingFontIcon()) {
                this._updateFontIconClasses();
            }
        };
        MdcIcon.prototype._usingFontIcon = function () {
            return !this.svgIcon;
        };
        MdcIcon.prototype._setSvgElement = function (svg) {
            this._clearSvgElement();
            // Workaround for IE11 and Edge ignoring `style` tags inside dynamically-created SVGs.
            // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
            // Do this before inserting the element into the DOM, in order to avoid a style recalculation.
            var styleTags = svg.querySelectorAll('style');
            for (var i = 0; i < styleTags.length; i++) {
                styleTags[i].textContent += ' ';
            }
            // Note: we do this fix here, rather than the icon registry, because the
            // references have to point to the URL at the time that the icon was created.
            if (this._location) {
                var path = this._location.getPathname();
                this._previousPath = path;
                this._cacheChildrenWithExternalReferences(svg);
                this._prependPathToReferences(path);
            }
            this._getHostElement().appendChild(svg);
        };
        MdcIcon.prototype._clearSvgElement = function () {
            var layoutElement = this._getHostElement();
            var childCount = layoutElement.childNodes.length;
            if (this._elementsWithExternalReferences) {
                this._elementsWithExternalReferences.clear();
            }
            // Remove existing non-element child nodes and SVGs, and add the new SVG element. Note that
            // we can't use innerHTML, because IE will throw if the element has a data binding.
            while (childCount--) {
                var child = layoutElement.childNodes[childCount];
                // 1 corresponds to Node.ELEMENT_NODE. We remove all non-element nodes in order to get rid
                // of any loose text nodes, as well as any SVG elements in order to remove any old icons.
                if (child.nodeType !== 1 || child.nodeName.toLowerCase() === 'svg') {
                    layoutElement.removeChild(child);
                }
            }
        };
        MdcIcon.prototype._updateFontIconClasses = function () {
            if (!this._usingFontIcon()) {
                return;
            }
            var elem = this._getHostElement();
            var fontSetClasses = this.fontSet ?
                [this._iconRegistry.classNameForFontAlias(this.fontSet)] :
                this._iconRegistry.getDefaultFontSetClass();
            this._previousFontSetClass.forEach(function (className) { return elem.classList.remove(className); });
            fontSetClasses.forEach(function (className) { return elem.classList.add(className); });
            this._previousFontSetClass = fontSetClasses;
            if (this.fontIcon !== this._previousFontIconClass) {
                if (this._previousFontIconClass) {
                    elem.classList.remove(this._previousFontIconClass);
                }
                if (this.fontIcon) {
                    elem.classList.add(this.fontIcon);
                }
                this._previousFontIconClass = this.fontIcon;
            }
        };
        /**
         * Cleans up a value to be used as a fontIcon or fontSet.
         * Since the value ends up being assigned as a CSS class, we
         * have to trim the value and omit space-separated values.
         */
        MdcIcon.prototype._cleanupFontValue = function (value) {
            return typeof value === 'string' ? value.trim().split(' ')[0] : value;
        };
        /**
         * Prepends the current path to all elements that have an attribute pointing to a `FuncIRI`
         * reference. This is required because WebKit browsers require references to be prefixed with
         * the current path, if the page has a `base` tag.
         */
        MdcIcon.prototype._prependPathToReferences = function (path) {
            var elements = this._elementsWithExternalReferences;
            if (elements) {
                elements.forEach(function (attrs, element) {
                    attrs.forEach(function (attr) {
                        element.setAttribute(attr.name, "url('" + path + "#" + attr.value + "')");
                    });
                });
            }
        };
        /**
         * Caches the children of an SVG element that have `url()`
         * references that we need to prefix with the current path.
         */
        MdcIcon.prototype._cacheChildrenWithExternalReferences = function (element) {
            var elementsWithFuncIri = element.querySelectorAll(funcIriAttributeSelector);
            var elements = this._elementsWithExternalReferences =
                this._elementsWithExternalReferences || new Map();
            var _loop_1 = function (i) {
                funcIriAttributes.forEach(function (attr) {
                    var elementWithReference = elementsWithFuncIri[i];
                    var value = elementWithReference.getAttribute(attr);
                    var match = value ? value.match(funcIriPattern) : null;
                    if (match) {
                        var attributes = elements.get(elementWithReference);
                        if (!attributes) {
                            attributes = [];
                            elements.set(elementWithReference, attributes);
                        }
                        attributes.push({ name: attr, value: match[1] });
                    }
                });
            };
            for (var i = 0; i < elementsWithFuncIri.length; i++) {
                _loop_1(i);
            }
        };
        /** Retrieves the DOM element of the component host. */
        MdcIcon.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcIcon.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-icon, [mdcIcon]',
                        exportAs: 'mdcIcon',
                        host: {
                            '[attr.role]': 'role',
                            'class': 'ngx-mdc-icon',
                            '[class.ngx-mdc-icon--inline]': 'inline'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcIcon.ctorParameters = function () { return [
            { type: i0.ElementRef },
            { type: MdcIconRegistry },
            { type: String, decorators: [{ type: i0.Attribute, args: ['aria-hidden',] }] },
            { type: undefined, decorators: [{ type: i0.Inject, args: [MDC_ICON_LOCATION,] }] }
        ]; };
        MdcIcon.propDecorators = {
            inline: [{ type: i0.Input }],
            svgIcon: [{ type: i0.Input }],
            role: [{ type: i0.Input }],
            fontSet: [{ type: i0.Input }],
            fontIcon: [{ type: i0.Input }]
        };
        return MdcIcon;
    }());

    var ICON_DECLARATIONS = [
        MdcIcon,
        MdcMaterialIcons
    ];
    var MdcIconModule = /** @class */ (function () {
        function MdcIconModule() {
        }
        MdcIconModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: ICON_DECLARATIONS,
                        declarations: ICON_DECLARATIONS
                    },] }
        ];
        return MdcIconModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcRipple = /** @class */ (function () {
        function MdcRipple(element, foundation) {
            this.element = element;
            this.initialized = false;
            this._foundation = foundation || new ripple.MDCRippleFoundation(MdcRipple.createAdapter({
                _root: element.nativeElement
            }));
        }
        MdcRipple.createAdapter = function (instance) {
            var adapter = {
                addClass: function (className) { return instance._root.classList.add(className); },
                removeClass: function (className) { return instance._root.classList.remove(className); },
                browserSupportsCssVars: function () { return typeof window !== 'undefined' ? ripple.util.supportsCssVariables(window) : false; },
                isUnbounded: function () { return coercion.coerceBooleanProperty(instance.unbounded); },
                isSurfaceActive: function () { return matches(instance._root, ':active'); },
                isSurfaceDisabled: function () { return coercion.coerceBooleanProperty(instance.disabled); },
                containsEventTarget: function (target) { return instance._root.contains(target); },
                registerDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                deregisterDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                registerResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.addEventListener('resize', handler) : {}; },
                deregisterResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.removeEventListener('resize', handler) : {}; },
                updateCssVariable: function (varName, value) {
                    return instance._root.style.setProperty(varName, value);
                },
                computeBoundingRect: function () { return typeof document === 'object' && !!document ?
                    instance._root.getBoundingClientRect() : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                getWindowPageOffset: function () { return typeof window !== 'undefined' ?
                    ({ x: window.pageXOffset, y: window.pageYOffset }) : ({ x: 0, y: 0 }); },
                registerInteractionHandler: function (evtType, handler) {
                    return instance._root.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return instance._root.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }
            };
            return adapter;
        };
        MdcRipple.prototype.init = function () {
            if (!this.initialized) {
                this._foundation.init();
                this.initialized = true;
            }
        };
        MdcRipple.prototype.destroy = function () {
            if (this.initialized) {
                this.initialized = false;
                this._foundation.destroy();
            }
        };
        MdcRipple.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcRipple.prototype.activateRipple = function (event) {
            var _this = this;
            setTimeout(function () { return _this._foundation.activate(event); });
        };
        MdcRipple.prototype.deactivateRipple = function () {
            var _this = this;
            setTimeout(function () { return _this._foundation.deactivate(); });
        };
        MdcRipple.prototype.handleBlur = function () {
            this._foundation.handleBlur();
        };
        MdcRipple.decorators = [
            { type: i0.Injectable }
        ];
        /** @nocollapse */
        MdcRipple.ctorParameters = function () { return [
            { type: i0.ElementRef },
            { type: ripple.MDCRippleFoundation, decorators: [{ type: i0.Optional }] }
        ]; };
        return MdcRipple;
    }());

    var MdcRippleDirective = /** @class */ (function () {
        function MdcRippleDirective(_ripple, elementRef) {
            this._ripple = _ripple;
            this.elementRef = elementRef;
            this._primary = false;
            this._secondary = false;
            this._disabled = false;
            this._unbounded = false;
            this._root = this.elementRef.nativeElement;
            this._ripple = this._createRipple();
        }
        Object.defineProperty(MdcRippleDirective.prototype, "attachTo", {
            get: function () {
                return this._attachTo;
            },
            set: function (element) {
                var _a, _b;
                this._attachTo = element;
                (_b = (_a = this._attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('mdc-ripple-surface');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "primary", {
            get: function () {
                return this._primary;
            },
            set: function (value) {
                this._primary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "secondary", {
            get: function () {
                return this._secondary;
            },
            set: function (value) {
                this._secondary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "unbounded", {
            get: function () {
                return this._unbounded;
            },
            set: function (value) {
                this._unbounded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRippleDirective.prototype.ngOnChanges = function (changes) {
            if (changes['primary'] && this.attachTo) {
                if (this._primary) {
                    this.attachTo.classList.add('mdc-ripple-surface--primary');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--primary');
                }
            }
            if (changes['secondary'] && this.attachTo) {
                if (this._secondary) {
                    this.attachTo.classList.add('mdc-ripple-surface--accent');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--accent');
                }
            }
        };
        MdcRippleDirective.prototype.ngAfterViewInit = function () {
            this._ripple.init();
        };
        MdcRippleDirective.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcRippleDirective.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add(className); }, computeBoundingRect: function () { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); }, isSurfaceActive: function () { return matches(_this.attachTo, ':active'); }, isSurfaceDisabled: function () { return _this._disabled; }, isUnbounded: function () { return _this._unbounded; }, removeClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className); }, updateCssVariable: function (varName, value) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(varName, value); }, registerInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()); }, deregisterInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcRippleDirective.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcRipple], mdc-ripple',
                        providers: [MdcRipple],
                    },] }
        ];
        /** @nocollapse */
        MdcRippleDirective.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: i0.ElementRef }
        ]; };
        MdcRippleDirective.propDecorators = {
            attachTo: [{ type: i0.Input }],
            primary: [{ type: i0.Input }],
            secondary: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            unbounded: [{ type: i0.Input }]
        };
        return MdcRippleDirective;
    }());

    var MdcRippleModule = /** @class */ (function () {
        function MdcRippleModule() {
        }
        MdcRippleModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcRippleDirective],
                        declarations: [MdcRippleDirective]
                    },] }
        ];
        return MdcRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /**
     * Injection token used to provide the parent MdcTabBar component to MdcTab.
     */
    var MDC_TAB_BAR_PARENT_COMPONENT = new i0.InjectionToken('MDC_TAB_BAR_PARENT_COMPONENT');
    var nextUniqueId = 0;
    var MdcTabLabel = /** @class */ (function () {
        function MdcTabLabel(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTabLabel.decorators = [
            { type: i0.Directive, args: [{
                        selector: 'mdc-tab-label, [mdcTabLabel]',
                        host: { 'class': 'mdc-tab__text-label' }
                    },] }
        ];
        /** @nocollapse */
        MdcTabLabel.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcTabLabel;
    }());
    var MdcTabIcon = /** @class */ (function () {
        function MdcTabIcon(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTabIcon.decorators = [
            { type: i0.Directive, args: [{
                        selector: 'mdc-tab-icon, [mdcTabIcon]',
                        host: { 'class': 'mdc-tab__icon' }
                    },] }
        ];
        /** @nocollapse */
        MdcTabIcon.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcTabIcon;
    }());
    var MdcTab = /** @class */ (function (_super) {
        __extends(MdcTab, _super);
        function MdcTab(_ngZone, _changeDetectorRef, _ripple, elementRef, _parent) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._ripple = _ripple;
            _this.elementRef = elementRef;
            _this._parent = _parent;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._uniqueId = "mdc-tab-" + ++nextUniqueId;
            _this.id = _this._uniqueId;
            _this._stacked = false;
            _this._fixed = false;
            _this._disabled = false;
            _this._focusOnActivate = true;
            _this.interacted = new i0.EventEmitter();
            _this._root = _this.elementRef.nativeElement;
            return _this;
        }
        Object.defineProperty(MdcTab.prototype, "stacked", {
            get: function () {
                return this._stacked;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._stacked) {
                    this._stacked = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTab.prototype, "fixed", {
            get: function () {
                return this._fixed;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._fixed) {
                    this._fixed = newValue;
                    this._changeDetectorRef.detectChanges();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTab.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTab.prototype, "focusOnActivate", {
            get: function () {
                return this._focusOnActivate;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._focusOnActivate) {
                    this._focusOnActivate = newValue;
                    this._foundation.setFocusOnActivate(this._focusOnActivate);
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcTab.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                setAttr: function (attr, value) { return _this._getHostElement().setAttribute(attr, value); },
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                activateIndicator: function (previousIndicatorClientRect) {
                    return _this.tabIndicator.activate(previousIndicatorClientRect);
                },
                deactivateIndicator: function () { return _this.tabIndicator.deactivate(); },
                notifyInteracted: function () { return _this.interacted.emit({ detail: { tabId: _this.id, tab: _this } }); },
                getOffsetLeft: function () { return _this._getHostElement().offsetLeft; },
                getOffsetWidth: function () { return _this._getHostElement().offsetWidth; },
                getContentOffsetLeft: function () { return _this.content.nativeElement.offsetLeft; },
                getContentOffsetWidth: function () { return _this.content.nativeElement.offsetWidth; },
                focus: function () { return _this._getHostElement().focus(); }
            };
            return new tab.MDCTabFoundation(adapter);
        };
        MdcTab.prototype.ngOnInit = function () {
            this._foundation.init();
            this._loadListeners();
        };
        MdcTab.prototype.ngAfterViewInit = function () {
            this._ripple = this._createRipple();
            this._ripple.init();
        };
        MdcTab.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            this._ripple.destroy();
        };
        Object.defineProperty(MdcTab.prototype, "active", {
            /** Getter for the active state of the tab */
            get: function () {
                return this._foundation.isActive();
            },
            enumerable: true,
            configurable: true
        });
        /** Activates the tab */
        MdcTab.prototype.activate = function (computeIndicatorClientRect) {
            this._foundation.activate(computeIndicatorClientRect);
        };
        /** Deactivates the tab */
        MdcTab.prototype.deactivate = function () {
            this._foundation.deactivate();
        };
        /** Returns the indicator's client rect */
        MdcTab.prototype.computeIndicatorClientRect = function () {
            return this.tabIndicator.computeContentClientRect();
        };
        MdcTab.prototype.computeDimensions = function () {
            return this._foundation.computeDimensions();
        };
        MdcTab.prototype.getTabBarParent = function () {
            return this._parent;
        };
        MdcTab.prototype.focus = function () {
            this._getHostElement().focus();
        };
        MdcTab.prototype._createRipple = function () {
            var rippleSurface = this.rippleSurface.nativeElement;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { return rippleSurface.classList.add(className); }, removeClass: function (className) { return rippleSurface.classList.remove(className); }, updateCssVariable: function (varName, value) { return rippleSurface.style.setProperty(varName, value); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcTab.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getHostElement(), 'click').pipe(operators.takeUntil(_this._destroy))
                    .subscribe(function () { return _this._ngZone.run(function () {
                    if (!_this.active && !_this._disabled) {
                        _this._foundation.handleClick();
                    }
                }); });
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcTab.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTab.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcTab], mdc-tab',
                        exportAs: 'mdcTab',
                        host: {
                            '[id]': 'id',
                            'role': 'tab',
                            'class': 'mdc-tab',
                            '[class.mdc-tab--stacked]': 'stacked',
                            '[class.mdc-tab--min-width]': 'fixed',
                            '[class.ngx-mdc-tab--disabled]': 'disabled'
                        },
                        template: "<div #content class=\"mdc-tab__content\">\r\n  <mdc-icon class=\"mdc-tab__icon\" *ngIf=\"icon\">{{icon}}</mdc-icon>\r\n  <ng-content select=\"mdc-icon\"></ng-content>\r\n  <span class=\"mdc-tab__text-label\" *ngIf=\"label\">{{label}}</span>\r\n  <ng-content></ng-content>\r\n  <ng-container *ngIf=\"fixed\">\r\n    <ng-container *ngTemplateOutlet=\"indicator\"></ng-container>\r\n  </ng-container>\r\n</div>\r\n<ng-container *ngIf=\"!fixed\">\r\n  <ng-container *ngTemplateOutlet=\"indicator\"></ng-container>\r\n</ng-container>\r\n<ng-template #indicator>\r\n  <mdc-tab-indicator></mdc-tab-indicator>\r\n</ng-template>\r\n<div #ripplesurface class=\"mdc-tab__ripple\"></div>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None,
                        providers: [MdcRipple]
                    }] }
        ];
        /** @nocollapse */
        MdcTab.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ChangeDetectorRef },
            { type: MdcRipple },
            { type: i0.ElementRef },
            { type: undefined, decorators: [{ type: i0.Optional }, { type: i0.Inject, args: [MDC_TAB_BAR_PARENT_COMPONENT,] }] }
        ]; };
        MdcTab.propDecorators = {
            id: [{ type: i0.Input }],
            label: [{ type: i0.Input }],
            icon: [{ type: i0.Input }],
            stacked: [{ type: i0.Input }],
            fixed: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            focusOnActivate: [{ type: i0.Input }],
            interacted: [{ type: i0.Output }],
            content: [{ type: i0.ViewChild, args: ['content', { static: false },] }],
            rippleSurface: [{ type: i0.ViewChild, args: ['ripplesurface', { static: false },] }],
            tabIndicator: [{ type: i0.ViewChild, args: [MdcTabIndicator, { static: false },] }]
        };
        return MdcTab;
    }(MDCComponent));

    var TAB_DECLARATIONS = [
        MdcTab,
        MdcTabIcon,
        MdcTabLabel
    ];
    var MdcTabModule = /** @class */ (function () {
        function MdcTabModule() {
        }
        MdcTabModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [
                            i3.CommonModule,
                            MdcTabIndicatorModule,
                            MdcIconModule
                        ],
                        exports: TAB_DECLARATIONS,
                        declarations: TAB_DECLARATIONS
                    },] }
        ];
        return MdcTabModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var SCROLLER_EVENTS = [
        'keydown',
        'mousedown',
        'pointerdown',
        'touchstart',
        'wheel'
    ];
    var MdcTabScroller = /** @class */ (function (_super) {
        __extends(MdcTabScroller, _super);
        function MdcTabScroller(_ngZone, _platform, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._platform = _platform;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._align = null;
            _this._scrollAreaEventsSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcTabScroller.prototype, "align", {
            get: function () {
                return this._align;
            },
            set: function (value) {
                this.setAlign(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabScroller.prototype, "scrollAreaEvents", {
            /** Combined stream of all of the scroll area events. */
            get: function () {
                var _this = this;
                return rxjs.merge.apply(void 0, __spread(SCROLLER_EVENTS.map(function (evt) {
                    return rxjs.fromEvent(_this._getScrollArea(), evt, { passive: platform.supportsPassiveEventListeners() });
                })));
            },
            enumerable: true,
            configurable: true
        });
        MdcTabScroller.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                eventTargetMatchesSelector: function (evtTarget, selector) { return matches(evtTarget, selector); },
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                addScrollAreaClass: function (className) { return _this.area.nativeElement.classList.add(className); },
                setScrollAreaStyleProperty: function (propName, value) {
                    return _this.area.nativeElement.style.setProperty(propName, value);
                },
                setScrollContentStyleProperty: function (propName, value) {
                    return _this.content.nativeElement.style.setProperty(propName, value);
                },
                getScrollContentStyleValue: function (propName) {
                    return _this._platform.isBrowser ? window.getComputedStyle(_this.content.nativeElement).getPropertyValue(propName) : '';
                },
                setScrollAreaScrollLeft: function (scrollX) { return _this.area.nativeElement.scrollLeft = scrollX; },
                getScrollAreaScrollLeft: function () { return _this.area.nativeElement.scrollLeft; },
                getScrollContentOffsetWidth: function () { return _this.content.nativeElement.offsetWidth; },
                getScrollAreaOffsetWidth: function () { return _this.area.nativeElement.offsetWidth; },
                computeScrollAreaClientRect: function () {
                    return _this._platform.isBrowser ? _this.area.nativeElement.getBoundingClientRect() : {};
                },
                computeScrollContentClientRect: function () {
                    return _this._platform.isBrowser ? _this.content.nativeElement.getBoundingClientRect() : {};
                },
                computeHorizontalScrollbarHeight: function () {
                    return _this._platform.isBrowser ? tabScroller.util.computeHorizontalScrollbarHeight(document) : 0;
                }
            };
            return new tabScroller.MDCTabScrollerFoundation(adapter);
        };
        MdcTabScroller.prototype.ngAfterViewInit = function () {
            this._foundation.init();
            this._loadListeners();
        };
        MdcTabScroller.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            if (this._scrollAreaEventsSubscription) {
                this._scrollAreaEventsSubscription.unsubscribe();
            }
        };
        MdcTabScroller.prototype.setAlign = function (align) {
            this._getHostElement().classList.remove("mdc-tab-scroller--align-" + this._align);
            this._align = align;
            if (align) {
                this._getHostElement().classList.add("mdc-tab-scroller--align-" + align);
            }
        };
        /** Returns the current visual scroll position */
        MdcTabScroller.prototype.getScrollPosition = function () {
            if (!this._platform.isBrowser) {
                return -1;
            }
            return this._foundation.getScrollPosition();
        };
        /** Returns the width of the scroll content */
        MdcTabScroller.prototype.getScrollContentWidth = function () {
            return this.content.nativeElement.offsetWidth;
        };
        /** Increments the scroll value by the given amount */
        MdcTabScroller.prototype.incrementScroll = function (scrollXIncrement) {
            if (!this._platform.isBrowser) {
                return;
            }
            this._foundation.incrementScroll(scrollXIncrement);
        };
        /** Scrolls to the given pixel position */
        MdcTabScroller.prototype.scrollTo = function (scrollX) {
            this._foundation.scrollTo(scrollX);
        };
        MdcTabScroller.prototype._loadListeners = function () {
            var _this = this;
            this._scrollAreaEventsSubscription = this.scrollAreaEvents.pipe()
                .subscribe(function () { return _this._foundation.handleInteraction(); });
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getScrollContent(), 'transitionend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._getScrollContent();
                }))
                    .subscribe(function (evt) { return _this._ngZone.run(function () { return _this._foundation.handleTransitionEnd(evt); }); });
            });
        };
        MdcTabScroller.prototype._getScrollArea = function () {
            return this.area.nativeElement;
        };
        MdcTabScroller.prototype._getScrollContent = function () {
            return this.content.nativeElement;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTabScroller.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTabScroller.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcTabScroller], mdc-tab-scroller',
                        exportAs: 'mdcTabScroller',
                        host: {
                            'class': 'mdc-tab-scroller'
                        },
                        template: "<div #area class=\"mdc-tab-scroller__scroll-area\">\r\n  <div #content class=\"mdc-tab-scroller__scroll-content\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcTabScroller.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: platform.Platform },
            { type: i0.ElementRef }
        ]; };
        MdcTabScroller.propDecorators = {
            align: [{ type: i0.Input }],
            area: [{ type: i0.ViewChild, args: ['area', { static: true },] }],
            content: [{ type: i0.ViewChild, args: ['content', { static: true },] }]
        };
        return MdcTabScroller;
    }(MDCComponent));

    var MdcTabScrollerModule = /** @class */ (function () {
        function MdcTabScrollerModule() {
        }
        MdcTabScrollerModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcTabScroller],
                        declarations: [MdcTabScroller]
                    },] }
        ];
        return MdcTabScrollerModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcTabActivatedEvent = /** @class */ (function () {
        function MdcTabActivatedEvent(source, index, tab) {
            this.source = source;
            this.index = index;
            this.tab = tab;
        }
        return MdcTabActivatedEvent;
    }());
    var MdcTabBar = /** @class */ (function (_super) {
        __extends(MdcTabBar, _super);
        function MdcTabBar(_platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._initialized = false;
            _this._fade = false;
            _this._stacked = false;
            _this._fixed = false;
            _this._align = null;
            _this._iconIndicator = null;
            _this._useAutomaticActivation = true;
            _this._activeTabIndex = 0;
            _this._focusOnActivate = true;
            _this.activated = new i0.EventEmitter();
            /** Subscription to changes in tabs. */
            _this._changeSubscription = null;
            /** Subscription to interaction events in tabs. */
            _this._tabInteractionSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcTabBar.prototype, "fade", {
            get: function () {
                return this._fade;
            },
            set: function (value) {
                this._fade = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "stacked", {
            get: function () {
                return this._stacked;
            },
            set: function (value) {
                this._stacked = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "fixed", {
            get: function () {
                return this._fixed;
            },
            set: function (value) {
                this._fixed = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "align", {
            get: function () {
                return this._align;
            },
            set: function (value) {
                this._align = value || 'start';
                this._syncTabScroller();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "iconIndicator", {
            get: function () {
                return this._iconIndicator;
            },
            set: function (value) {
                this._iconIndicator = value;
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "useAutomaticActivation", {
            get: function () {
                return this._useAutomaticActivation;
            },
            set: function (value) {
                this._useAutomaticActivation = coercion.coerceBooleanProperty(value);
                this._foundation.setUseAutomaticActivation(this._useAutomaticActivation);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "activeTabIndex", {
            get: function () {
                return this._activeTabIndex;
            },
            set: function (value) {
                if (this.activeTabIndex !== value) {
                    this._activeTabIndex = value;
                    this.activateTab(this.activeTabIndex);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "focusOnActivate", {
            get: function () {
                return this._focusOnActivate;
            },
            set: function (value) {
                this._focusOnActivate = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "tabInteractions", {
            /** Combined stream of all of the tab interaction events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.tabs.map(function (tab) { return tab.interacted; })));
            },
            enumerable: true,
            configurable: true
        });
        MdcTabBar.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                scrollTo: function (scrollX) { return _this.tabScroller.scrollTo(scrollX); },
                incrementScroll: function (scrollXIncrement) { return _this.tabScroller.incrementScroll(scrollXIncrement); },
                getScrollPosition: function () { return _this.tabScroller.getScrollPosition(); },
                getScrollContentWidth: function () { return _this.tabScroller.getScrollContentWidth(); },
                getOffsetWidth: function () { return _this._getHostElement().offsetWidth; },
                isRTL: function () { return _this._platform.isBrowser ?
                    window.getComputedStyle(_this._getHostElement()).getPropertyValue('direction') === 'rtl' : false; },
                setActiveTab: function (index) { return _this.activateTab(index); },
                activateTabAtIndex: function (index, clientRect) {
                    if (_this._indexIsInRange(index)) {
                        _this.tabs.toArray()[index].activate(clientRect);
                    }
                },
                deactivateTabAtIndex: function (index) {
                    if (_this._indexIsInRange(index)) {
                        _this.tabs.toArray()[index].deactivate();
                    }
                },
                focusTabAtIndex: function (index) { return _this.tabs.toArray()[index].focus(); },
                getTabIndicatorClientRectAtIndex: function (previousActiveIndex) {
                    if (!_this._platform.isBrowser) {
                        return { height: 0, width: 0, bottom: 0, top: 0, left: 0, right: 0 };
                    }
                    if (!_this._indexIsInRange(previousActiveIndex)) {
                        previousActiveIndex = _this.activeTabIndex;
                    }
                    return _this.tabs.toArray()[previousActiveIndex].computeIndicatorClientRect();
                },
                getTabDimensionsAtIndex: function (index) { return _this.tabs.toArray()[index].computeDimensions(); },
                getPreviousActiveTabIndex: function () { return _this.tabs.toArray().findIndex(function (_) { return _.active; }); },
                getFocusedTabIndex: function () {
                    return _this._platform.isBrowser ? _this.tabs.toArray().findIndex(function (tab) {
                        return tab.elementRef.nativeElement === document.activeElement;
                    }) : -1;
                },
                getIndexOfTabById: function (id) { return _this.tabs.toArray().findIndex(function (tab) { return id === tab.id; }); },
                getTabListLength: function () { return _this.tabs.length; },
                notifyTabActivated: function (index) {
                    return _this.activated.emit({ source: _this, index: index, tab: _this.tabs.toArray()[index] });
                }
            };
            return new tabBar.MDCTabBarFoundation(adapter);
        };
        MdcTabBar.prototype.ngOnChanges = function (changes) {
            if (!this._initialized) {
                return;
            }
            if (changes['align']) {
                this._syncTabScroller();
            }
        };
        MdcTabBar.prototype.ngAfterContentInit = function () {
            var _this = this;
            this._initialized = true;
            this._foundation.init();
            // When the list changes, re-subscribe
            this._changeSubscription = this.tabs.changes.pipe(operators.startWith(null)).subscribe(function () {
                Promise.resolve().then(function () {
                    if (_this.tabs.length) {
                        _this._syncTabs();
                        _this._syncTabScroller();
                        _this.activateTab(_this.activeTabIndex);
                        _this._resetTabSubscriptions();
                    }
                });
            });
        };
        MdcTabBar.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            if (this._changeSubscription) {
                this._changeSubscription.unsubscribe();
            }
            this._dropSubscriptions();
        };
        MdcTabBar.prototype._syncTabs = function () {
            var _this = this;
            if (!this.tabs) {
                return;
            }
            this.tabs.forEach(function (tab) {
                tab.stacked = _this._stacked;
                tab.fixed = _this._fixed;
                tab.tabIndicator.fade = _this._fade;
                tab.tabIndicator.icon = _this._iconIndicator;
                tab.focusOnActivate = _this._focusOnActivate;
            });
        };
        MdcTabBar.prototype._syncTabScroller = function () {
            if (this.tabScroller) {
                this.tabScroller.align = this.align;
            }
        };
        MdcTabBar.prototype._resetTabSubscriptions = function () {
            this._dropSubscriptions();
            this._listenToTabInteraction();
        };
        MdcTabBar.prototype._dropSubscriptions = function () {
            if (this._tabInteractionSubscription) {
                this._tabInteractionSubscription.unsubscribe();
                this._tabInteractionSubscription = null;
            }
        };
        /** Listens to interaction events on each tab. */
        MdcTabBar.prototype._listenToTabInteraction = function () {
            var _this = this;
            this._tabInteractionSubscription = this.tabInteractions.subscribe(function (event) {
                var previousTab = _this.getActiveTab();
                if (previousTab) {
                    previousTab.tabIndicator.active = false;
                }
                event.detail.tab.tabIndicator.active = true;
                _this._foundation.handleTabInteraction(event);
            });
        };
        /** Activates the tab at the given index */
        MdcTabBar.prototype.activateTab = function (index) {
            if (!this.tabs) {
                return;
            }
            this.activeTabIndex = index;
            if (this._platform.isBrowser) {
                this._foundation.activateTab(index);
            }
            this._changeDetectorRef.markForCheck();
        };
        /** Scrolls the tab at the given index into view */
        MdcTabBar.prototype.scrollIntoView = function (index) {
            this._foundation.scrollIntoView(index);
        };
        MdcTabBar.prototype.getActiveTabIndex = function () {
            return this.tabs.toArray().findIndex(function (_) { return _.active; });
        };
        MdcTabBar.prototype.getActiveTab = function () {
            return this.tabs.toArray().find(function (_) { return _.active; });
        };
        /** Returns an index for given tab */
        MdcTabBar.prototype.getTabIndex = function (tab) {
            return this.tabs.toArray().indexOf(tab);
        };
        /** Disable or enable the tab at the given index */
        MdcTabBar.prototype.disableTab = function (index, disabled) {
            if (!this.tabs) {
                return;
            }
            this.tabs.toArray()[index].disabled = coercion.coerceBooleanProperty(disabled);
        };
        MdcTabBar.prototype._onKeydown = function (evt) {
            this._foundation.handleKeyDown(evt);
        };
        MdcTabBar.prototype._indexIsInRange = function (index) {
            return index >= 0 && index < this.tabs.length;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTabBar.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTabBar.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcTabBar], mdc-tab-bar',
                        exportAs: 'mdcTabBar',
                        host: {
                            'role': 'tablist',
                            'class': 'mdc-tab-bar',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None,
                        providers: [{ provide: MDC_TAB_BAR_PARENT_COMPONENT, useExisting: MdcTabBar }]
                    }] }
        ];
        /** @nocollapse */
        MdcTabBar.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef }
        ]; };
        MdcTabBar.propDecorators = {
            fade: [{ type: i0.Input }],
            stacked: [{ type: i0.Input }],
            fixed: [{ type: i0.Input }],
            align: [{ type: i0.Input }],
            iconIndicator: [{ type: i0.Input }],
            useAutomaticActivation: [{ type: i0.Input }],
            activeTabIndex: [{ type: i0.Input }],
            focusOnActivate: [{ type: i0.Input }],
            activated: [{ type: i0.Output }],
            tabScroller: [{ type: i0.ContentChild, args: [MdcTabScroller, { static: true },] }],
            tabs: [{ type: i0.ContentChildren, args: [MdcTab, { descendants: true },] }]
        };
        return MdcTabBar;
    }(MDCComponent));

    var MdcTabBarModule = /** @class */ (function () {
        function MdcTabBarModule() {
        }
        MdcTabBarModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [
                            MdcTabIndicatorModule,
                            MdcTabModule,
                            MdcTabScrollerModule
                        ],
                        exports: [
                            MdcTabBar,
                            MdcTabIndicatorModule,
                            MdcTabModule,
                            MdcTabScrollerModule
                        ],
                        declarations: [MdcTabBar]
                    },] }
        ];
        return MdcTabBarModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcTabActivatedEvent = MdcTabActivatedEvent;
    exports.MdcTabBar = MdcTabBar;
    exports.MdcTabBarModule = MdcTabBarModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-tab-bar.umd.js.map
